export var DataSourceProvider;
(function (DataSourceProvider) {
    DataSourceProvider["AZURE"] = "azure";
    DataSourceProvider["DRUID"] = "druid";
})(DataSourceProvider || (DataSourceProvider = {}));
//# sourceMappingURL=customer-usage.js.map